import { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    // Primary Colors
    colorPrimary: '#2563EB',
    colorPrimaryHover: '#1D4ED8',
    colorPrimaryActive: '#1E40AF',
    
    // Border Radius
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 4,
    borderRadiusXS: 2,
    
    // Font Configuration
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 16,
    fontSizeSM: 14,
    fontSizeLG: 18,
    fontSizeXL: 20,
    
    // Spacing
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,
    paddingXXS: 4,
    
    margin: 16,
    marginLG: 24,
    marginSM: 12,
    marginXS: 8,
    marginXXS: 4,
    
    // Colors
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#F8FAFC',
    colorBgLayout: '#F3F4F6',
    colorBorder: '#D1D5DB',
    colorBorderSecondary: '#E5E7EB',
    
    // Text Colors
    colorText: '#000000',
    colorTextSecondary: '#6B7280',
    colorTextTertiary: '#9CA3AF',
    colorTextQuaternary: '#D1D5DB',
    
    // Status Colors
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorInfo: '#3B82F6',
    
    // Form Controls
    controlHeight: 48,
    controlHeightSM: 40,
    controlHeightLG: 56,
    controlHeightXS: 32,
    
    // Line Height
    lineHeight: 1.5,
    lineHeightLG: 1.6,
    lineHeightSM: 1.4,
    
    // Box Shadow
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    boxShadowSecondary: '0 1px 3px rgba(0, 0, 0, 0.1)',
    boxShadowTertiary: '0 1px 2px rgba(0, 0, 0, 0.05)',
  },
  components: {
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      fontWeight: 600,
      borderRadius: 8,
    },
    Input: {
      paddingBlock: 12,
      paddingInline: 16,
      borderRadius: 8,
      fontSize: 16,
    },
    InputNumber: {
      paddingBlock: 12,
      paddingInline: 16,
      borderRadius: 8,
    },
    Select: {
      borderRadius: 8,
    },
    Form: {
      itemMarginBottom: 24,
      labelFontSize: 14,
      labelColor: '#374151',
      // labelFontWeight: 500,
    },
    Card: {
      borderRadius: 12,
      paddingLG: 24,
    },
    Modal: {
      borderRadius: 12,
    },
    Drawer: {
      borderRadius: 12,
    },
    Table: {
      borderRadius: 8,
      headerBg: '#F8FAFC',
    },
    Tabs: {
      borderRadius: 8,
    },
    Menu: {
      borderRadius: 8,
      itemBorderRadius: 6,
    },
    Notification: {
      borderRadius: 8,
    },
    Message: {
      borderRadius: 8,
    },
    Alert: {
      borderRadius: 8,
    },
    Progress: {
      borderRadius: 8,
    },
    Badge: {
      borderRadius: 8,
    },
    Tag: {
      borderRadius: 6,
    },
  },
}; 